module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA8AAAAOCAYAAADwikbvAAAAj0lEQVQokc3TIQ7CQBCF4a+lCgSecBcSULVwDjgMJL0FSGRPQ/AIUNAiWNy2pVU88zI784s32UkWi7w2UFnwZABbpy3NKc7Bo2qCRzhW41mOU6h/hvdYpY8rLHGIDSVhYU2ZW3ttmTv1f3Dhk1fwog+8RVlN5lBi1wd+YZ3eL7DBMzaUxR6Dbjq+7RcedBxvacwa5Yzn6g8AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/report/design/assets/22c.png
// module id = x3Nb
// module chunks = 65